/*
  Mở modal xác nhận khi có sản phẩm được thêm vào giỏ.

  Xem chú thích đầu snippets/cart-added-modal.liquid cho phần "vì sao bắt ở tầng
  mạng". Tóm tắt: trang có ba đường thêm giỏ (nút theme, nút nhân bản của
  Customily, quick-add ở trang danh mục) nhưng chỉ một endpoint /cart/add.

  Bọc cả fetch lẫn XMLHttpRequest: theme dùng fetch, còn app thì tuỳ — Customily
  và các app cũ vẫn chạy XHR. Bọc một cái là hụt đường kia.

  Nguyên tắc khi bọc: KHÔNG đổi hành vi. Vẫn trả về đúng promise/response gốc,
  đọc dữ liệu trên bản sao (`clone()`), và mọi lỗi phân tích đều nuốt lặng —
  modal hỏng thì thôi không hiện, tuyệt đối không được làm hỏng việc thêm giỏ.
*/
(function () {
  var MODAL_ID = 'cl-atc-modal';
  var ADD_PATH = /\/cart\/add(\.js)?(\?|$)/;

  function modal() {
    return document.getElementById(MODAL_ID);
  }

  /* ---------- Định dạng tiền ---------- */

  /*
    Bản rút gọn của Shopify.formatMoney. Không dùng thẳng hàm của Shopify vì nó
    chỉ có mặt khi theme nạp option_selection.js — theme này thì không.
  */
  function formatMoney(cents, format) {
    var value = (typeof cents === 'number' ? cents : parseInt(cents, 10)) || 0;
    var pattern = format || '${{amount}}';

    function group(number, decimals, thousands, decimal) {
      var fixed = (value / 100).toFixed(decimals);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return decimals && parts[1] ? whole + decimal + parts[1] : whole;
    }

    var placeholder = pattern.match(/\{\{\s*(\w+)\s*\}\}/);
    var name = placeholder ? placeholder[1] : 'amount';
    var out;

    switch (name) {
      case 'amount_no_decimals':
        out = group(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        out = group(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        out = group(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        out = group(value, 2, "'", '.');
        break;
      default:
        out = group(value, 2, ',', '.');
    }

    return pattern.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /* ---------- Đổ dữ liệu ---------- */

  /*
    Ảnh trong phản hồi là ảnh gốc, có khi 2000px — ép về đúng cỡ ô hiển thị
    (272px cho màn hình 2x) bằng tham số width của CDN Shopify.
  */
  function sizedImage(url, width) {
    if (!url) return '';
    if (url.indexOf('cdn.shopify.com') === -1 && url.indexOf('/cdn/') === -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  /*
    Dòng mô tả dưới tên sản phẩm: biến thể trước, rồi tới các ô cá nhân hoá.

    Bỏ qua thuộc tính bắt đầu bằng "_": đó là dữ liệu kỹ thuật app tự đính kèm
    (id bản dựng, đường dẫn ảnh render...), khách đọc không hiểu gì.
  */
  function describe(item) {
    var rows = [];

    (item.options_with_values || []).forEach(function (option) {
      if (!option || !option.value) return;
      if (option.name === 'Title' && option.value === 'Default Title') return;
      rows.push([option.name, option.value]);
    });

    var props = item.properties || {};
    Object.keys(props).forEach(function (key) {
      if (key.charAt(0) === '_') return;
      var value = props[key];
      if (value === null || value === undefined || value === '') return;
      rows.push([key, String(value)]);
    });

    return rows;
  }

  /*
    Số lượng KHÁCH VỪA THÊM, đọc từ thân request.

    Phản hồi của Shopify trả về dòng hàng SAU KHI cộng dồn: giỏ đang có 2 cái,
    thêm 1 cái nữa thì phản hồi ghi quantity = 3. Đưa nguyên con số đó lên modal
    "Item has been added" là sai thông điệp — khách thêm 1 mà đọc thấy 3.

    Không đọc được (thân request lạ kiểu) thì trả null và rơi về số của phản hồi,
    vẫn còn hơn không hiện gì.
  */
  function requestedQuantity(body) {
    try {
      if (!body) return null;

      if (typeof body === 'string') {
        var text = body.trim();
        if (text.charAt(0) === '{') {
          var data = JSON.parse(text);
          if (Array.isArray(data.items) && data.items[0]) return Number(data.items[0].quantity) || null;
          return Number(data.quantity) || null;
        }
        return Number(new URLSearchParams(text).get('quantity')) || null;
      }

      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        return Number(body.get('quantity')) || null;
      }

      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        return Number(body.get('quantity')) || null;
      }
    } catch (e) {
      /* Thân request không đọc được — bỏ qua. */
    }
    return null;
  }

  function fill(item, addedQty) {
    var box = modal();
    if (!box || !item) return false;

    var image = box.querySelector('.cl-atc-modal__image');
    var url = item.featured_image ? item.featured_image.url : item.image;
    if (image) {
      /* Gỡ dấu "đã tải" trước khi đổi src, nếu không lần mở sau ảnh cũ còn hiện
         nguyên rồi bị thay đột ngột bằng ảnh mới. */
      image.classList.remove('cl-atc-loaded');
      image.src = sizedImage(url, 272);
      image.alt = (item.featured_image && item.featured_image.alt) || item.product_title || '';
      /* Ảnh đã nằm sẵn trong cache thì `load` có thể không kịp bắt. */
      if (image.complete) image.classList.add('cl-atc-loaded');
      /* Sản phẩm không có ảnh: giấu hẳn ô thay vì để khung xám trống. */
      var media = box.querySelector('.cl-atc-modal__media');
      if (media) media.style.display = url ? '' : 'none';
    }

    var title = box.querySelector('.cl-atc-modal__title');
    if (title) title.textContent = item.product_title || item.title || '';

    var options = box.querySelector('.cl-atc-modal__options');
    if (options) {
      options.textContent = '';
      describe(item).forEach(function (row) {
        var li = document.createElement('li');
        li.appendChild(document.createTextNode(row[0] + ': '));
        var b = document.createElement('b');
        b.textContent = row[1];
        li.appendChild(b);
        options.appendChild(li);
      });
    }

    var shown = addedQty || item.quantity || 1;

    var qty = box.querySelector('.cl-atc-modal__qty-value');
    if (qty) qty.textContent = shown;

    var price = box.querySelector('.cl-atc-modal__price');
    if (price) {
      var cents;
      if (addedQty) {
        /* Giá của riêng phần vừa thêm, để khớp với số lượng đang hiện. */
        var unit = item.final_price;
        if (unit === undefined || unit === null) unit = item.price || 0;
        cents = unit * addedQty;
      } else {
        cents = item.final_line_price;
        if (cents === undefined || cents === null) cents = item.line_price;
        if (cents === undefined || cents === null) cents = (item.price || 0) * (item.quantity || 1);
      }
      price.textContent = formatMoney(cents, window.CL_MONEY_FORMAT);

      /*
        RỒI ĐỌC LẠI GIỎ THẬT ĐỂ SỬA CON SỐ.

        Phép nhân `đơn giá × số lượng` ở trên SAI khi đơn có giảm giá theo cặp.
        Shopify TÁCH dòng hàng: mua 4 cái thì giỏ có 2 dòng — 2 cái nguyên giá và
        2 cái nửa giá — mà /cart/add.js chỉ trả về một dòng. Vớ phải dòng nửa giá
        rồi nhân 4 là ra $40.00 trong khi giỏ tính $59.98 (đo 24/08/2026).

        Không tính tay nữa: cộng `final_line_price` của mọi dòng cùng variant.
        Đây là đúng con số khách sẽ trả, không phải con số mình suy ra.

        Gọi sau khi đã vẽ xong modal nên không làm chậm lúc mở; hỏng mạng thì giữ
        nguyên số cũ, không để trống.
      */
      var variantId = item.variant_id || item.id;
      if (variantId && window.fetch) {
        window
          .fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .then(function (cart) {
            if (!cart || !Array.isArray(cart.items)) return;

            var sum = 0;
            var origSum = 0;
            var qtySum = 0;
            cart.items.forEach(function (line) {
              if (String(line.variant_id || line.id) !== String(variantId)) return;
              sum += line.final_line_price || line.line_price || 0;
              origSum += line.original_line_price || line.line_price || 0;
              qtySum += line.quantity || 0;
            });

            if (!qtySum) return;

            /*
              Hiện luôn phần tiết kiệm: tổng chưa giảm gạch ngang + số tiền bớt
              được. `original_line_price` là giá chưa áp discount của dòng đó —
              cộng lại rồi trừ đi tổng thật là ra, khỏi tính theo phần trăm.
            */
            price.textContent = '';
            var totalEl = document.createElement('span');
            totalEl.className = 'cl-atc-modal__price-now';
            totalEl.textContent = formatMoney(sum, window.CL_MONEY_FORMAT);
            price.appendChild(totalEl);

            var saved = origSum - sum;
            if (saved > 0) {
              var wasEl = document.createElement('s');
              wasEl.className = 'cl-atc-modal__price-was';
              wasEl.textContent = formatMoney(origSum, window.CL_MONEY_FORMAT);
              price.appendChild(wasEl);

              var saveEl = document.createElement('span');
              saveEl.className = 'cl-atc-modal__price-save';
              saveEl.textContent = 'Save ' + formatMoney(saved, window.CL_MONEY_FORMAT);
              price.appendChild(saveEl);
            }

            /* Số lượng hiện theo đúng tổng đang có trong giỏ, để con số tiền và
               con số lượng luôn nói về cùng một thứ. */
            var qtyEl = box.querySelector('.cl-atc-modal__qty-value');
            if (qtyEl) qtyEl.textContent = qtySum;
          })
          .catch(function () {});
      }
    }

    /*
      Dòng "N of this item in your cart".

      `item.quantity` trong phản hồi là số lượng của dòng hàng SAU khi cộng dồn,
      tức đúng bằng tổng món này đang có trong giỏ — không phải gọi thêm
      /cart.js để biết.

      Chỉ hiện khi tổng khác số vừa thêm: lần thêm đầu tiên hai con số bằng
      nhau, nói lại thành thừa. Không đọc được số vừa thêm thì cũng ẩn, vì lúc
      đó không so sánh được và dễ thành câu vô nghĩa.
    */
    var inCart = box.querySelector('.cl-atc-modal__in-cart');
    if (inCart) {
      var total = item.quantity || 0;
      if (addedQty && total > addedQty) {
        inCart.textContent = total + ' of this item in your cart';
        inCart.hidden = false;
      } else {
        inCart.textContent = '';
        inCart.hidden = true;
      }
    }

    return true;
  }

  /* ---------- Trạng thái chờ trên nút ---------- */

  /*
    Từ lúc bấm tới lúc modal mở đo được ~1,7 giây (chờ /cart/add.js trả về). Nút
    của theme không tự đổi gì trong quãng đó — không class, không disabled,
    không spinner — nên người mua tưởng bấm hụt và bấm lại.

    Đánh dấu đúng cái nút vừa bấm, gỡ khi modal mở. Có hạn 10 giây phòng khi
    request chết giữa chừng, không để nút mờ vĩnh viễn.
  */
  var PENDING_CLASS = 'cl-atc-pending';
  var pendingButton = null;
  var pendingTimer = null;

  function clearPending() {
    if (pendingTimer) {
      clearTimeout(pendingTimer);
      pendingTimer = null;
    }
    if (pendingButton) {
      pendingButton.classList.remove(PENDING_CLASS);
      pendingButton.removeAttribute('aria-busy');
      pendingButton = null;
    }
  }

  function markPending(button) {
    clearPending();
    if (!button) return;
    pendingButton = button;
    button.classList.add(PENDING_CLASS);
    button.setAttribute('aria-busy', 'true');
    pendingTimer = setTimeout(clearPending, 10000);
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest) return;
      var button = event.target.closest(
        '#customily-cart-btn, .customily-cart-btn, [id$="__add-to-cart"], .add-to-cart-button, [name="add"]'
      );
      /* Nút trong chính modal (View cart) cũng khớp vài selector trên — bỏ qua. */
      if (!button || button.closest('#' + MODAL_ID)) return;
      markPending(button);
    },
    true
  );

  /* ---------- Mở / đóng ---------- */

  function open(item, addedQty) {
    var box = modal();
    if (!box || !fill(item, addedQty)) return;
    if (box.open) box.close();
    box.classList.remove('cl-atc-closing');
    if (typeof box.showModal === 'function') box.showModal();
    else box.setAttribute('open', '');
    clearPending();
  }

  /*
    Đóng có hiệu ứng: gắn lớp cho chạy animation ra, xong mới gọi close().

    Không gọi close() ngay được — dialog đóng là rời khỏi top layer, animation
    không còn gì để chạy. Chờ `animationend`, kèm hẹn giờ dự phòng cho trường
    hợp animation bị tắt hoặc sự kiện không bắn (tab ẩn chẳng hạn).
  */
  function close(box) {
    if (!box || !box.open || box.classList.contains('cl-atc-closing')) return;
    box.classList.add('cl-atc-closing');

    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      box.removeEventListener('animationend', onEnd);
      box.classList.remove('cl-atc-closing');
      box.close();
    };
    var onEnd = function (event) {
      if (event.target === box) finish();
    };

    box.addEventListener('animationend', onEnd);
    setTimeout(finish, 400);
  }

  /* ---------- Đọc phản hồi ---------- */

  /*
    /cart/add.js trả về dòng hàng vừa tạo. Thêm một món thì là chính đối tượng
    đó; thêm nhiều món cùng lúc (`items: [...]`) thì là { items: [...] }. Lấy
    món đầu — modal chỉ nói về một món, và mọi đường thêm giỏ ở đây đều thêm
    từng món một.
  */
  function firstItem(data) {
    if (!data || typeof data !== 'object') return null;
    if (Array.isArray(data.items)) return data.items[0] || null;
    if (data.id || data.variant_id) return data;
    return null;
  }

  function handleBody(text, addedQty) {
    /*
      volume-offer-designs.js thêm N món bằng N lần /cart/add liên tiếp. Mở modal
      mỗi lần là nó che trang giữa chừng — nên nó bật cờ này rồi tự gọi
      `clAtcShow` một lần khi xong hết.
    */
    if (window.clAtcHold) return;
    try {
      var item = firstItem(JSON.parse(text));
      if (item) open(item, addedQty);
    } catch (e) {
      /* Phản hồi không phải JSON (lỗi mạng, trang chặn...) — im lặng bỏ qua. */
    }
  }

  window.clAtcShow = function (item, addedQty) {
    open(item, addedQty);
  };

  /* ---------- Bọc fetch ---------- */

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var promise = nativeFetch.apply(this, arguments);
      if (!ADD_PATH.test(url)) return promise;

      /* Chỉ đọc được thân request khi nó đi qua `init`. Dạng Request object thì
         thân là stream, đọc vào là hỏng luôn request gốc — bỏ qua, rơi về số
         lượng của phản hồi. */
      var addedQty = requestedQuantity(init && init.body);

      return promise.then(function (response) {
        if (response && response.ok) {
          try {
            response
              .clone()
              .text()
              .then(function (text) {
                handleBody(text, addedQty);
              }, function () {});
          } catch (e) {
            /* clone() hỏng thì thôi, không đụng tới response gốc. */
          }
        }
        return response;
      });
    };
  }

  /* ---------- Bọc XMLHttpRequest ---------- */

  if (window.XMLHttpRequest) {
    var nativeOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        this.__clAddToCart = ADD_PATH.test(String(url));
      } catch (e) {
        this.__clAddToCart = false;
      }
      return nativeOpen.apply(this, arguments);
    };

    var nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function (body) {
      if (this.__clAddToCart) {
        var addedQty = requestedQuantity(body);
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) handleBody(this.responseText, addedQty);
        });
      }
      return nativeSend.apply(this, arguments);
    };
  }

  /* ---------- Đóng modal ---------- */

  document.addEventListener('click', function (event) {
    var box = modal();
    if (!box || !box.open) return;

    if (event.target.closest && event.target.closest('[data-cl-atc-close]')) {
      close(box);
      return;
    }

    /* Bấm ra ngoài thẻ: <dialog> nhận cú bấm lên chính nó khi trúng phần nền. */
    if (event.target === box) close(box);
  });

  /*
    Phím Esc: trình duyệt tự đóng dialog ngay, bỏ qua hiệu ứng. Chặn hành vi mặc
    định rồi tự đóng theo đúng luồng có animation.
  */
  document.addEventListener('keydown', function (event) {
    var box = modal();
    if (!box || !box.open || event.key !== 'Escape') return;
    event.preventDefault();
    close(box);
  });

  /* Ảnh về sau modal vài chục ms — mờ dần vào thay vì hiện phịch. */
  (function watchImage() {
    var box = modal();
    var image = box && box.querySelector('.cl-atc-modal__image');
    if (!image) {
      document.addEventListener('DOMContentLoaded', watchImage);
      return;
    }
    var show = function () {
      image.classList.add('cl-atc-loaded');
    };
    image.addEventListener('load', show);
    image.addEventListener('error', show);
    if (image.complete && image.getAttribute('src')) show();
  })();
})();
